import { render, staticRenderFns } from "./GamePlayCanvas.vue?vue&type=template&id=55315987&"
import script from "./GamePlayCanvas.vue?vue&type=script&lang=js&"
export * from "./GamePlayCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports